<template>
    <header class="mh-header"><button v-if="back" class="icon-btn" @click="$router.back()"><i
                class="bi bi-chevron-left"></i></button><img v-else src="@/assets/logo1.png" class="logo" alt="MH13">
        <div class="heading" @click="selectLocation"><strong>{{ displayedTitle }}</strong><small
                v-if="subtitle">{{ subtitle }}</small></div><button class="icon-btn" aria-label="Notifications"
            @click="$router.push('/profile?section=notifications')"><i class="bi bi-bell"></i></button>
    </header>
</template>
<script>import { getStored, setStored } from "@/utils/storage"; export default { name: "AppHeader", props: { title: { default: "Solapur, MH" }, subtitle: String, back: Boolean, locationPicker: Boolean }, data() { return { savedLocation: getStored("last_selected_location", "Solapur, MH") } }, computed: { displayedTitle() { return this.locationPicker ? this.savedLocation : this.title } }, methods: { selectLocation() { if (!this.locationPicker) return; const value = window.prompt("Enter city or area", this.savedLocation); if (value?.trim()) { this.savedLocation = value.trim(); setStored("last_selected_location", this.savedLocation) } } } }</script>
<style
    scoped>
    .mh-header {
        height: 76px;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        color: #fff;
        background: linear-gradient(135deg, #5821ff, #8624df);
        position: sticky;
        top: 0;
        z-index: 50;
        overflow: hidden
    }

    .mh-header:after {
        content: "";
        position: absolute;
        width: 180px;
        height: 180px;
        right: -55px;
        top: -110px;
        border-radius: 50%;
        background: #ffffff13
    }

    .logo {
        width: 86px;
        height: 48px;
        object-fit: contain;
        filter: drop-shadow(0 3px 7px #0002)
    }

    .heading {
        display: flex;
        flex: 1;
        min-width: 0;
        flex-direction: column;
        z-index: 1
    }

    .heading strong {
        font-size: 18px
    }

    .heading small {
        font-size: 10px;
        color: #ffffffbf
    }

    .icon-btn {
        z-index: 1;
        width: 42px;
        height: 42px;
        border: 0;
        border-radius: 50%;
        background: #ffffff17;
        color: #fff;
        font-size: 20px
    }
</style>
